import m from "mithril";

const Pager = {
    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,
    isDragging: false,
    isHorizontalDrag: false,
    
    view(vnode) {
        // Mithril passes child vnodes on vnode.children, not attrs.children
        const children = vnode.children || [];
        const activeIndex = vnode.attrs.activeIndex || 0;
        const total = children.length;
        // Support both callback names for flexibility
        const onPageChange = vnode.attrs.onPageChange || vnode.attrs.onIndexChange;

        return m("div", {
            class: "pager-container overflow-hidden relative",
            style: { 
                touchAction: "none",
                userSelect: "none",
                cursor: this.isDragging ? "grabbing" : "grab"
            },
            onpointerdown: (e) => {
                if (e.button !== undefined && e.button !== 0) return;
                this.isDragging = true;
                this.isHorizontalDrag = false;
                this.startX = e.clientX;
                this.startY = e.clientY;
                this.currentX = e.clientX;
                this.currentY = e.clientY;
                e.target.setPointerCapture(e.pointerId);
            },
            onpointermove: (e) => {
                if (!this.isDragging) return;
                this.currentX = e.clientX;
                this.currentY = e.clientY;

                const deltaX = Math.abs(this.currentX - this.startX);
                const deltaY = Math.abs(this.currentY - this.startY);

                if (!this.isHorizontalDrag) {
                    this.isHorizontalDrag = deltaX > 12 && deltaX > deltaY;
                }

                m.redraw();
            },
            onpointerup: (e) => {
                if (!this.isDragging) return;
                this.isDragging = false;
                
                const diff = this.startX - this.currentX;
                const absDiff = Math.abs(diff);
                const threshold = Math.min(120, window.innerWidth * 0.12);

                if (this.isHorizontalDrag && absDiff > threshold && onPageChange) {
                    if (total === 2) {
                        onPageChange(activeIndex === 0 ? 1 : 0);
                    } else if (diff > 0 && activeIndex < total - 1) {
                        onPageChange(activeIndex + 1);
                    } else if (diff < 0 && activeIndex > 0) {
                        onPageChange(activeIndex - 1);
                    }
                }
                
                this.startX = 0;
                this.startY = 0;
                this.currentX = 0;
                this.currentY = 0;
                this.isHorizontalDrag = false;
                e.target.releasePointerCapture(e.pointerId);
                m.redraw();
            },
            onpointercancel: (e) => {
                this.isDragging = false;
                this.startX = 0;
                this.startY = 0;
                this.currentX = 0;
                this.currentY = 0;
                this.isHorizontalDrag = false;
                e.target.releasePointerCapture(e.pointerId);
                m.redraw();
            }
        }, [
            m("div", {
                class: "pager-wrapper flex transition-transform duration-300 ease-out",
                style: {
                    width: `${total * 100}%`,
                    transform: `translateX(-${(activeIndex * (100 / total)) + (this.isHorizontalDrag ? (this.startX - this.currentX) / window.innerWidth * (100 / total) : 0)}%)`,
                    transition: this.isDragging ? 'none' : 'transform 0.3s ease-out'
                }
            }, children.map(child => 
            m("div", {
                class: "flex-shrink-0 min-h-screen overflow-x-hidden relative",
                style: {
                    width: `${100 / total}%`,
                    maxWidth: `${100 / total}%`
                }
            }, child)
            ))
        ]);
    }
};

export default Pager;
